import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Filler, Tooltip, Legend);

// Categorical slots in fixed order (validated: adjacent CVD ΔE >= 9.1).
// Slot 1 = татан авалт (C), slot 2 = борлуулалт (D) everywhere so a series
// keeps its color.
export const SERIES = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];

const TEXT_SECONDARY = '#667085';
const GRID = '#eef0f4';

ChartJS.defaults.font.family = '"Inter", "Roboto", "Helvetica", "Arial", sans-serif';
ChartJS.defaults.font.size = 12;
ChartJS.defaults.color = TEXT_SECONDARY;
ChartJS.defaults.maintainAspectRatio = false;

export const formatNumber = (v) => {
    const n = Number(v) || 0;
    return n.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

// Compact axis ticks: 1.2K, 3.4M
export const formatCompact = (v) => {
    const n = Number(v) || 0;
    const abs = Math.abs(n);
    if (abs >= 1e9) return (n / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
    if (abs >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
    if (abs >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
    return String(n);
};

const tooltip = {
    backgroundColor: '#1d2939',
    titleColor: '#ffffff',
    bodyColor: '#e4e8ef',
    padding: 10,
    cornerRadius: 8,
    boxPadding: 4,
    usePointStyle: true,
    callbacks: {
        label: (ctx) => ` ${ctx.dataset.label}: ${formatNumber(ctx.parsed[ctx.chart.options.indexAxis === 'y' ? 'x' : 'y'])}`,
    },
};

const legend = {
    position: 'top',
    align: 'end',
    labels: { usePointStyle: true, pointStyle: 'rectRounded', boxWidth: 8, boxHeight: 8, padding: 16 },
};

// Vertical bars / lines over a category axis.
export const categoryOptions = ({ showLegend = true } = {}) => ({
    responsive: true,
    interaction: { mode: 'index', intersect: false },
    plugins: { legend: { ...legend, display: showLegend }, tooltip },
    scales: {
        x: { grid: { display: false }, border: { display: false }, ticks: { maxRotation: 0, autoSkipPadding: 12 } },
        y: { beginAtZero: true, grid: { color: GRID }, border: { display: false }, ticks: { callback: formatCompact, maxTicksLimit: 6 } },
    },
});

// Horizontal bars (ranked lists).
export const rankOptions = () => ({
    responsive: true,
    indexAxis: 'y',
    interaction: { mode: 'nearest', axis: 'y', intersect: false },
    plugins: { legend: { display: false }, tooltip },
    scales: {
        x: { beginAtZero: true, grid: { color: GRID }, border: { display: false }, ticks: { callback: formatCompact, maxTicksLimit: 6 } },
        y: { grid: { display: false }, border: { display: false } },
    },
});

// Thin bars with rounded data-ends, 2px gap between neighbours.
export const barStyle = (color) => ({
    backgroundColor: color,
    hoverBackgroundColor: color,
    borderRadius: 4,
    borderSkipped: 'start',
    borderColor: 'transparent',
    borderWidth: 1,
    maxBarThickness: 28,
    categoryPercentage: 0.7,
    barPercentage: 0.9,
});

export const lineStyle = (color) => ({
    borderColor: color,
    backgroundColor: color + '1f',
    borderWidth: 2,
    pointRadius: 0,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 2,
    pointHoverBorderColor: '#ffffff',
    pointBackgroundColor: color,
    tension: 0.3,
    fill: true,
});
